import {
  AbstractControl,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { BUS_KEYWORD_TEXT_LIMIT, BUS_TAG_TEXT_LIMIT, TEXT_AREA_LIMIT_2M, TEXT_AREA_LIMIT_L, TEXT_AREA_LIMIT_M, TEXT_AREA_LIMIT_S } from "../utils/constant";

export const EmailValidation = [Validators.required, Validators.email];
export const EmailValidationNew = [
  Validators.required,
  Validators.pattern(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,50})$/
  ),
];
// export const EmailValidationNew = [Validators.required, Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]*\.([a-z]{2,50})$/)];
// const candianPostalCode = "^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$";
export const EmailValidationNewNoReq = [
  // Validators.required,
  Validators.pattern(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,50})$/
  ),
];
const candianPostalCode =
  "^(?!.*[])[a-vxyA-VXY][0-9][a-zA-Z] ?[0-9][a-zA-Z][0-9]$";
// const candianPostalCode = "^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$";
// export const aphaNumericPattern =
//   /(?![\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]+$)([a-zA-Z0-9][\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]*)+$/;
// export const aphaNumericPattern =
//   /(?![\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]+$)([a-zA-Z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19][\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]*)+$/;
// export const aphaNumericPattern =/^(\s+\S+\s*)*(?!\s).*$/;
export const aphaNumericPattern = /[\S]/;

export const websiteUrlPattern =
  /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
export const GSTNOPattern =
  "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$";
export const PanNOPattern =
  // "/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/";
  "[A-Z]{5}[0-9]{4}[A-Z]{1}";
export const PasswordValidation = [
  Validators.required,
  Validators.minLength(4),
  Validators.maxLength(50),
];

export const PasswordValidationNew = [
  Validators.required,
  Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/),
];
export const PasswordValidationNumeric = [
  Validators.pattern("^[0-9]*$"),
  Validators.required,
  Validators.maxLength(4),
];

export const CanadianPostalCodeCalidation = [
  Validators.required,
  Validators.pattern(candianPostalCode),
];

export const WebsiteUrlValidation = [
  Validators.required,
  Validators.pattern(websiteUrlPattern),
];

export const WebsiteUrlValidationNoReq = [
  // Validators.required,
  Validators.pattern(websiteUrlPattern),
];


export const UrlValidation = [
  // Validators.required,
  Validators.pattern(websiteUrlPattern),
];

export const DomainValidation = [Validators.required];

export const OptionalTextValidation = [
  Validators.minLength(2),
  Validators.maxLength(50),
];
export const RequiredTextValidation = OptionalTextValidation.concat([
  Validators.required,
]);
export const RequiredCodeValidation = [
  Validators.required,
  Validators.maxLength(20),
];

export const OneCharValidation = [
  Validators.minLength(1),
  Validators.maxLength(1),
];
export const BirthDateValidation = [
  Validators.required,
  Validators.min(new Date().getFullYear() - 100),
  Validators.max(new Date().getFullYear()),
];

export const USAZipCodeValidation = [
  Validators.required,
  Validators.pattern(/^\d{5}(?:[-\s]\d{4})?$/),
];
export const USAPhoneNumberValidation = [
  Validators.required,
  Validators.pattern(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/),
];

export const MobileOrEmailValidation = [
  Validators.required,
  Validators.pattern(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|(\d{3})\D?\D?(\d{3})\D?(\d{4})$/
  ),
];

export const NumberValidation = [
  Validators.pattern(/^-?(0|[1-9]\d*)?$/),
  Validators.minLength(10),
  // Validators.maxLength(15)
];

export const DecimalNumberValidation = [
  Validators.pattern(/^[1-9]\d*(\.\d+)?$/),
];

export const SpaceNotAllow = [
  Validators.required,
  // Validators.pattern(/^\S*$/)
  Validators.pattern(/^([a-zA-Z0-9]+s?)*$/)

];

export const onlyPostiveNoZero = [
  Validators.pattern("/^(?![,.0]*$)\d{1,4}(?:[.,]\d{1,2})?$/gm"),
  Validators.required,
];

export function minLengthArray(min: number) {
  return (c: AbstractControl): { [key: string]: any } => {
    if (c.value.length >= min) {
      return null;
    }
    return { minLengthArray: { valid: false } };
  };
}

export function firstLessThanSecond(first: string, second: string) {
  return (group: FormGroup): { [key: string]: any } => {
    const firstVal = <Number>group.controls[first].value
      ? Number(group.controls[first].value).toFixed(10)
      : 0;
    const secondVal = <Number>group.controls[second].value
      ? Number(group.controls[second].value).toFixed(10)
      : 0;

    if (Number(firstVal) > Number(secondVal)) {
      return {
        hasGreaterValue: true,
      };
    }
  };
}

export const MobileValidation = [
  Validators.required,
  Validators.minLength(10),
  // Validators.maxLength(10),
  // Validators.pattern("\d{9}"),
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];
export const NumericValidation = [
  Validators.required,
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];
export const NumericValidationNoReq = [
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];
export const MobileValidationNoReq = [
  // Validators.required,
  Validators.minLength(10),
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];
export const GSTNoValidation = [
  Validators.required,
  Validators.pattern(GSTNOPattern),
];
export const GSTNoValidationNoReq = [
  // Validators.required,
  Validators.pattern(GSTNOPattern),
];
export const PanNoValidation = [
  Validators.required,
  Validators.pattern(PanNOPattern),
];
export const PanNoValidationNoReq = [
  // Validators.required,
  Validators.pattern(PanNOPattern),
];
export const MemberIdValidation = [
  Validators.required,
  Validators.minLength(11),
  // Validators.maxLength(10),
  // Validators.pattern("\d{9}"),
  Validators.pattern("^[0-9]*$"),
];
export const PincodeValidation = [
  Validators.required,
  Validators.minLength(6),
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];

export const PincodeValidationNoReq = [
  // Validators.required,
  // Validators.minLength(6),
  // Validators.maxLength(6),
  // Validators.pattern("^\d{6}$"),
  Validators.minLength(6),
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];


// export const ChangePasswordValidation = [
//   // (?![\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]+$)([a-zA-Z0-9][\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]*)+$/;
//   Validators.required,
//   Validators.minLength(8),
//   // Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$"),
//   // Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9\d!@#$%^&*]+$"),
//   Validators.pattern(
//     "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9d!@#$%^&*()_+={}\\[\\]\\-|\\:;'<>,./?]+$"
//   ),
// ];

export const ChangePasswordValidation = [
  // (?![\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]+$)([a-zA-Z0-9][\s~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/?]*)+$/;
  Validators.required,
  Validators.minLength(8),
  // Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$"),
  // Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9\d!@#$%^&*]+$"),
  // Validators.pattern(
  //   "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9d!@#$%^&*()_+={}\\[\\]\\-|\\:;'<>,./?]+$"
  // ),
];

export const MobileValidationWithoutRequired = [
  Validators.minLength(10),
  Validators.pattern("^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]*$"),
];

export const AlphaNumeric = [
  Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_S),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericNoReq = [
  // Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_S),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericTextAreaNoReq = [
  // Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_M),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericTextArea2MNoReq = [
  // Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_2M),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericBusTagNoReq = [
  // Validators.required,
  Validators.maxLength(BUS_TAG_TEXT_LIMIT),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericBusKeywordNoReq = [
  // Validators.required,
  Validators.maxLength(BUS_KEYWORD_TEXT_LIMIT),
  Validators.pattern(aphaNumericPattern),
];


export const AlphaNumericTextArea = [
  Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_M),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericTextAreaLargeNoReq = [
  // Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_L),
  Validators.pattern(aphaNumericPattern),
];

export const AlphaNumericTextAreaLarge = [
  Validators.required,
  Validators.maxLength(TEXT_AREA_LIMIT_L),
  Validators.pattern(aphaNumericPattern),
];


export function checkPercentage(per: string) {
  return (group: FormGroup): { [key: string]: any } => {
    const firstVal = <Number>group.controls[per].value
      ? Number(group.controls[per].value).toFixed(10)
      : 0;
    if (Number(firstVal) > 100) {
      return {
        hasGreaterValue: true,
      };
    }
  };
}

export function fromToDateValidation(fromDate: string, toDate: string) {
  return (group: FormGroup): { [key: string]: any } => {
    const from = <Date>group.controls[fromDate].value;
    const to = <Date>group.controls[toDate].value;
    if (null !== from && null !== to) {
      if (from > to) {
        return {
          hasGreaterValue: true,
        };
      }
    }
    return;
  };
}

export function firstEqualToSecond(first: string, second: string) {
  return (group: FormGroup): { [key: string]: any } => {
    const firstVal = <Number>group.controls[first].value
      ? Number(group.controls[first].value).toFixed(10)
      : 0;
    const secondVal = <Number>group.controls[second].value
      ? Number(group.controls[second].value).toFixed(10)
      : 0;

    if (firstVal && secondVal !== 0) {
      if (firstVal !== secondVal) {
        return {
          hasEqualValue: true,
        };
      }
    }
    return;
  };
}

export function passwordAndConfirmPassword(first: string, second: string) {
  return (group: FormGroup): { [key: string]: any } => {
    const firstVal = group.controls[first].value;
    const secondVal = group.controls[second].value;

    if (firstVal && secondVal) {
      if (firstVal !== secondVal) {
        return {
          hasEqualValue: true,
        };
      }
    }
    return;
  };
}

export const OTPValidation = [
  Validators.required,
  Validators.minLength(6),
  Validators.maxLength(6),
];

export const ValidationMessages = {
  name: [
    { type: "required", message: "val_name_req" },
    { type: "pattern", message: "val_name_req" },
  ],
  full_name: [
    { type: "required", message: "full_name_is_required" },
    { type: "pattern", message: "full_name_is_required" },
  ],
  business_type: [{ type: "required", message: "business_type_is_required" }],
  email: [
    { type: "required", message: "please_enter_an_email" },
    { type: "pattern", message: "you_must_enter_a_valid_email" },
  ],
  firstName: [
    { type: "required", message: "first_name_is_required" },
    { type: "pattern", message: "first_name_is_required" },
  ],
  userName: [
    { type: "required", message: "user_name_is_required" },
    { type: "pattern", message: "user_name_is_required" },
  ],
  lastName: [
    { type: "required", message: "last_name_is_required" },
    { type: "pattern", message: "last_name_is_required" },
  ],
  business_name: [{ type: "required", message: "business_name_is_required" },
  { type: "pattern", message: "business_name_is_required" }],
  business_info: [
    { type: "required", message: "business_information_is_required" },
    { type: "pattern", message: "business_information_is_required" },
    { type: "maxlength", message: "val_max_char_allow" }
  ],
  gst_no: [
    { type: "required", message: "gst_number_is_required" },
    { type: "pattern", message: "you_must_enter_a_valid_gst_number" },
  ],
  compney_name: [{ type: "required", message: "compney_name_is_required" }],
  website_url: [
    { type: "required", message: "website_url_is_required" },
    { type: "pattern", message: "you_must_enter_a_valid_website_url" },
  ],
  url_val: [
    { type: "required", message: "url_is_required" },
    { type: "pattern", message: "you_must_enter_a_valid_url" },
  ],
  business_hours: [
    { type: "required", message: "business_hours_is_reuired" },
    { type: "pattern", message: "business_hours_is_required" },
  ],
  reason: [{ type: "required", message: "reason_is_required" },
  { type: "pattern", message: "reason_is_required" },
  { type: "maxlength", message: "val_max_char_allow" }],
  business_tag: [{ type: "required", message: "bus_tag_is_required" },
  { type: "pattern", message: "bus_tag_is_required" },
  { type: "maxlength", message: "val_max_char_allow" }],
  business_keyword: [{ type: "required", message: "bus_keyword_is_required" },
  { type: "pattern", message: "bus_keyword_is_required" },
  { type: "maxlength", message: "val_max_char_allow" }],
  dob: [{ type: "required", message: "dob_is_required" }],
  designation: [
    { type: "required", message: "designation_is_required" },
    { type: "pattern", message: "designation_is_required" },
  ],
  password: [{ type: "required", message: "password_is_required" }],
  currentPassword: [{ type: "required", message: "enter_current_password" }],
  confirmPassword: [
    { type: "required", message: "confirm_password_is_required" },
  ],
  changePassword: [
    { type: "required", message: "please_enter_a_password" },
    {
      type: "pattern",
      message: "min_characters_should_include_lowercase_uppercase_digit",
    },
  ],
  passwordMatch: [
    { type: "required", message: "please_enter_the_same_password_again" },
  ],
  otp: [{ type: "required", message: "otp_is_required" }],
  member_id: [{ type: "required", message: "member_id_is_required" },
  { type: "pattern", message: "member_id_is_required" },],
  mobile_no: [
    { type: "required", message: "mobile_number_is_required" },
    { type: "pattern", message: "you_must_enter_a_valid_mobile_number" },
    {
      type: "minlength",
      message: "minimum_10_digit_mobile_number_is_required",
    },
  ],
  select_type: [{ type: "required", message: "select_type_is_required" }],
  contact_no: [
    { type: "required", message: "contact_number_is_required" },
    { type: "pattern", message: "you_must_enter_a_valid_contact_number" },
    {
      type: "minlength",
      message: "minimum_10_digit_contact_number_is_required",
    },
  ],
  whatsapp_no: [
    { type: "required", message: "whatsapp_number_is_required" },
    { type: "pattern", message: "you_must_enter_a_valid_whatsapp_number" },
    {
      type: "minlength",
      message: "minimum_10_digit_whatsapp_number_is_required",
    },
  ],
  phone_no: [
    { type: "required", message: "Phone number  is required." },
    { type: "pattern", message: "You must enter a valid phone number." },
    {
      type: "minlength",
      message: "Minimum 10 digit phone number is required.",
    },
  ],
  gender: [{ type: "required", message: "gender_is_required" }],
  state: [{ type: "required", message: "state_is_required" }],
  district: [{ type: "required", message: "district_is_required" }],
  taluka: [{ type: "required", message: "taluka_is_required" }],
  village: [{ type: "required", message: "village_is_required" },
  { type: "pattern", message: "village_is_required" },],
  village_area: [{ type: "required", message: "village_area_is_required" },
  { type: "pattern", message: "village_area_is_required" }],
  business_list_name: [
    { type: "required", message: "business_list_name_is_required" },
  ],
  bus_list_business_list_name: [
    { type: "required", message: "val_add_bus_name_is_required" },
  ],
  bus_list_subscription_cost: [
    { type: "required", message: "val_add_bus_sub_cost_is_required" },
  ],
  pincode: [
    // { type: "required", message: "pincode_is_required" },
    { type: "pattern", message: "val_invalid_format" },
    // { type: "minlength", message: "val_invalid_format" },
  ],
  pincode_req: [
    { type: "required", message: "pincode_is_required" },
    { type: "pattern", message: "val_invalid_format" },
    // { type: "minlength", message: "val_invalid_format" },
  ],
  trading_type: [{ type: "required", message: "Trading type  is required." }],
  product_name: [{ type: "required", message: "Product name  is required." }],
  subject: [{ type: "required", message: "val_inq_subject_is_req" },
  { type: "pattern", message: "val_inq_subject_is_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
  assign_to: [{ type: "required", message: "val_assignto_req" }],
  closing_date: [{ type: "required", message: "Closing date  is required." }],
  business: [{ type: "required", message: "Business  is required." }],
  date: [{ type: "required", message: "Date  is required." }],
  staff: [{ type: "required", message: "Staff  is required." }],
  message: [{ type: "required", message: "val_msg_req" },
  { type: "pattern", message: "val_msg_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
  servicesSales_validation: [
    { type: "required", message: "you_must_select_any_one_sevices_or_sales" },
  ],
  one_tra_type_validation: [
    { type: "required", message: "val_trading_type_req" },
  ],
  privacy_policy: [{ type: "required", message: "privacy_policy_is_required" }],
  add_com_short_name: [
    { type: "required", message: "val_add_com_short_name_req" },
  ],
  add_com_product_compney_name: [
    { type: "required", message: "val_add_com_name_req" },
  ],
  add_trad_trading_type: [
    { type: "required", message: "val_add_trad_type_req" },
  ],
  add_trad_bus_type: [
    { type: "required", message: "val_add_trad_bus_type_req" },
  ],
  add_prd_bus_type: [
    { type: "required", message: "val_add_prd_business_type" },
  ],
  add_prd_trading_type: [{ type: "required", message: "val_add_prd_type_req" }],
  add_prd_product_name: [
    { type: "required", message: "va_add_prd_product_name" },
  ],
  add_prd_product_keyword: [
    { type: "required", message: "va_add_prd_product_keyword" },
    { type: "pattern", message: "val_msg_req" },
  { type: "maxlength", message: "val_max_char_allow" }
  ],

  add_st_state_code: [{ type: "required", message: "val_state_code_req" }],
  add_dis_distrct_name: [{ type: "required", message: "val_add_distrct_name" }],
  add_tal_district_name: [{ type: "required", message: "val_add_tal_district_name" }],
  add_tal_taluka_name: [{ type: "required", message: "val_add_taluka_name_req" },
  { type: "pattern", message: "val_add_taluka_name_req" }],
  state_name_req: [{ type: "required", message: "val_state_name_req" },
  { type: "pattern", message: "val_state_name_req" }],
  district_name_req: [{ type: "required", message: "val_district_name_req" },
  { type: "pattern", message: "val_district_name_req" }],
  taluka_name_req: [{ type: "required", message: "val_taluka_name_req" },
  { type: "pattern", message: "val_taluka_name_req" }],
  village_name_req: [{ type: "required", message: "val_village_name_req" },
  { type: "pattern", message: "val_village_name_req" }],
  village_area_name_req: [{ type: "required", message: "val_village_area_name_req" },
  { type: "pattern", message: "val_village_area_name_req" }],
  bd_code: [
    { type: "required", message: "val_bd_code_req" },
    { type: "pattern", message: "val_bd_code_req" }
  ],
  group_name: [
    { type: "required", message: "val_grp_name_req" }
  ],
  parent_name: [
    { type: "required", message: "val_parent_name_req" }
  ],
  item_group_name: [
    { type: "required", message: "val_item_grp_name_req" }
  ],
  item_parent_name: [
    { type: "required", message: "val_item_parent_name_req" }
  ],
  salary: [
    { type: "required", message: "val_salary_is_req" },
  ],
  address: [
    { type: "required", message: "val_address_is_req" },
    { type: "pattern", message: "val_address_is_req" },
    { type: "maxlength", message: "val_max_char_allow" }
  ],
  addressline1: [
    { type: "required", message: "val_addressline1_req" },
    { type: "pattern", message: "val_addressline1_req" },
  ],
  doj: [{ type: "required", message: "doj_is_required" }],
  acc_set_tra_type: [{ type: "required", message: "val_trans_type_is_required" }],
  mannual_no: [{ type: "required", message: "val_mann_no_is_required" }],
  prefix: [{ type: "required", message: "val_prefix_is_required" }],
  suffix: [{ type: "required", message: "val_suffix_is_required" }],
  inq_subject: [
    { type: "required", message: "val_inq_subject_is_req" },
    { type: "pattern", message: "val_inq_subject_is_req" },
  ],
  adv_business_name: [{ type: "required", message: "val_adv_business_name_is_required" }],
  adv_amt: [
    { type: "required", message: "val_amt_is_required" },
  ],
  adv_display_area: [
    { type: "required", message: "val_adv_dis_area_is_req" },
  ],
  adv_space: [
    { type: "required", message: "val_adv_sp_is_req" },
  ],
  adv_noofnoti: [
    { type: "required", message: "val_adv_no_of_req" },
  ],
  ladger_comp_name: [
    { type: "required", message: "val_ent_tran_lad_com_name_req" },
  ],
  entry_transa_amt: [
    { type: "required", message: "val_ent_tran_lad_amt_is_req" },
  ],
  sel_pay_method: [{ type: "required", message: "val_pay_method_req" }],
  sel_ifsc_code: [{ type: "required", message: "val_ifsc_code_req" },
  { type: "pattern", message: "val_ifsc_code_req" }],
  bank_name: [{ type: "required", message: "val_bank_name_req" },
  { type: "pattern", message: "val_bank_name_req" }],
  sel_branch_name: [{ type: "required", message: "val_branch_name_req" },
  { type: "pattern", message: "val_branch_name_req" }],
  cheq_no: [{ type: "required", message: "val_cheq_no_req" }],
  cheq_date: [{ type: "required", message: "val_cheq_date_req" }],
  narration: [{ type: "required", message: "val_narra_req" },
  { type: "pattern", message: "val_narra_req" }],
  account_group: [{ type: "required", message: "val_grp_name_req" }],
  led_name: [{ type: "required", message: "val_led_name_req" }],
  auth_per_name: [{ type: "required", message: "val_auth_per_name_req" },
  { type: "pattern", message: "val_auth_per_name_req" }],
  pan_no: [{ type: "required", message: "val_pan_no_req" },
  { type: "pattern", message: "val_valid_pan" }],
  cust_address: [{ type: "required", message: "val_address_req" }],
  op_bal: [{ type: "required", message: "val_op_bal_req" }],
  op_bal_date: [{ type: "required", message: "va_op_bval_dt_req" }],
  crdr_led: [{ type: "required", message: "val_crdr_req" }],
  tran_date: [{ type: "required", message: "val_tra_date_req" }],
  tran_status: [{ type: "required", message: "val_tran_status_req" }],
  tran_amt: [{ type: "required", message: "val_tra_amt_req" }],
  tra_nara: [{ type: "required", message: "val_tra_nara_req" },
  { type: "pattern", message: "val_tra_nara_req" }],
  lang_id: [{ type: "required", message: "val_lang_id_req" }],
  lang_str: [{ type: "required", message: "val_lang_str_req" },
  { type: "pattern", message: "val_lang_str_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
  zone_no: [{ type: "required", message: "val_zone_no_req" }],
  zone_name: [{ type: "required", message: "val_zone_name_req" }],
  compl_bus_name: [{ type: "required", message: "val_compl_bus_name_req" }],
  compl_sub: [{ type: "required", message: "val_compl_sub_req" }],
  compl_com: [{ type: "required", message: "val_compl_com_req" },
  { type: "pattern", message: "val_compl_com_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
  compl_date: [{ type: "required", message: "val_compl_date_req" }],
  status: [{ type: "required", message: "val_status_req" }],
  compl_staff: [{ type: "required", message: "val_compl_staff_req" }],
  compl_cl_date: [{ type: "required", message: "val_compl_cldate_req" }],
  compl_coments: [{ type: "required", message: "val_compl_coments_req" },
  { type: "pattern", message: "val_compl_coments_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
  rating_val: [{ type: "required", message: "val_rating_req" }],
  role_member: [{ type: "required", message: "val_member_req" }],
  sel_img: [{ type: "required", message: "val_img_req" }],
  noti_text: [{ type: "required", message: "val_noti_text_req" },
  { type: "pattern", message: "val_noti_text_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
  start_time: [{ type: "required", message: "val_stime_req" }],
  end_time: [{ type: "required", message: "val_etime_req" }],
  invalid_trans_entry: [{ type: "required", message: "val_invalid_trans_req" }],
  send_link: [
    { type: "required", message: "val_send_link_req" },
    { type: "pattern", message: "val_send_link_req" },
  ],

  item_grp: [
    { type: "required", message: "val_item_grp_req" },
    { type: "pattern", message: "val_item_grp_req" },
  ],
  item_unit: [
    { type: "required", message: "val_item_unit_req" },
    { type: "pattern", message: "val_item_unit_req" },
  ],
  item_ope_stock_qty: [
    { type: "required", message: "val_openstock_qty_req" },
    { type: "pattern", message: "val_openstock_qty_req" },
  ],
  item_ope_stock_value: [
    { type: "required", message: "val_openstock_valu_req" },
    { type: "pattern", message: "val_openstock_valu_req" },
  ],
  item_text_cate: [
    { type: "required", message: "val_text_cate_req" },
    { type: "pattern", message: "val_text_cate_req" },
  ],
  item_hsnsac_cate: [
    { type: "required", message: "val_hsnsac_req" },
    { type: "pattern", message: "val_hsnsac_req" },
  ],
  item_sales_price: [
    { type: "required", message: "val_sales_price_req" },
    { type: "pattern", message: "val_sales_price_req" },
  ],
  item_pur_price: [
    { type: "required", message: "val_pur_price_req" },
    { type: "pattern", message: "val_pur_price_req" },
  ],
  item_mrp: [
    { type: "required", message: "val_mrp" },
    { type: "pattern", message: "val_mrp" },
  ],
  item_sale_price: [
    { type: "required", message: "val_sale_price" },
    { type: "pattern", message: "val_sale_price" },
  ],
  item_disc: [
    { type: "required", message: "val_disc" },
    { type: "pattern", message: "val_disc" },
  ],
  pay_method: [
    { type: "required", message: "val_sel_pay_method" },
  ],
  ref_no_ss: [
    { type: "required", message: "val_sel_ref_no_ss" },
  ],
  ref_no: [
    { type: "required", message: "val_ref_no_req" },
    { type: "pattern", message: "val_ref_no_req" },
  ],
  referal_id_val: [
    { type: "required", message: "val_ref_id_req" },
    { type: "pattern", message: "val_ref_id_req" },
  ],
  transaction_not_allowed: [
    { type: "required", message: "val_transaction_not_allow" },
    { type: "pattern", message: "val_transaction_not_allow" },
  ],
  transfer_amt: [
    { type: "required", message: "val_transfer_amt" },
    { type: "pattern", message: "val_transfer_amt" },
  ],
  transfer_memberid: [
    { type: "required", message: "val_transfer_memberid" },
    { type: "pattern", message: "val_transfer_memberid" },
  ],
  ad_postion: [
    { type: "required", message: "val_ad_postion" },
    { type: "pattern", message: "val_ad_postion" },
  ],
  ad_level: [
    { type: "required", message: "val_ad_level" },
    { type: "pattern", message: "val_ad_level" },
  ],
  ad_budget: [
    { type: "required", message: "val_ad_budget" },
    { type: "pattern", message: "val_ad_budget" },
  ],
  ad_limit: [
    { type: "required", message: "val_ad_limit" },
    { type: "pattern", message: "val_ad_limit" },
  ],
  ad_price: [
    { type: "required", message: "val_ad_price" },
    { type: "pattern", message: "val_ad_price" },
  ],
  ad_freq: [
    { type: "required", message: "val_ad_freq" },
  ],
  ad_date_time: [
    { type: "required", message: "val_adv_date_time" },
    { type: "pattern", message: "val_adv_date_time" },
  ],
  ad_date_time_used: [
    { type: "required", message: "val_adv_date_time_used" },
  ],
  adv_start_date: [
    { type: "required", message: "val_adv_start_date" },
    { type: "invalidDate", message: "val_adv_start_date" },
  ],
  adv_end_date: [
    { type: "required", message: "val_adv_end_date" },
  ],
  adv_img_text: [
    { type: "required", message: "val_adv_img_text" },
  ],
  discount_type: [
    { type: "required", message: "val_dis_type" },
  ],
  free_dis_amt: [
    { type: "required", message: "val_dis_amt" },
    { type: "pattern", message: "val_dis_amt" },
  ],
  dis_start_date: [
    { type: "required", message: "val_dis_start_date" },
    { type: "invalidDate", message: "val_dis_start_date" },
  ],
  dis_end_date: [
    { type: "required", message: "val_dis_end_date" },
    { type: "invalidDate", message: "val_dis_end_date" },
  ],
  free_trial_days: [
    { type: "required", message: "val_free_trial_days" },
    { type: "pattern", message: "val_free_trial_days" },
  ],
  already_date_used: [
    { type: "required", message: "val_already_date_used" },
  ],
  detail_type: [
    { type: "required", message: "val_detail_type_required" },
  ],
  end_date: [
    { type: "required", message: "val_end_date" },
  ],
  comment_txt: [{ type: "required", message: "val_comment_text_req" },
  { type: "pattern", message: "val_comment_text_req" },
  { type: "maxlength", message: "val_max_char_allow" }],
};

export function noWhitespaceValidator(control: FormControl) {
  const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'whitespace': true };
}